<div class="row mt-4 mb-4">
    <div class="col">
        <h5>Riepilogo</h5>
    </div>
</div>
<div class="table-container">
    <table mat-table matSort [dataSource]="this.interventoIniziale" multiTemplateDataRows>
        <!--       <ng-container matColumnDef="apri">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let sel">
                <button mat-button (click)="apriRichiesta(sel)">
                    <span>Seleziona</span>
                </button>
            </td>
        </ng-container>
-->
        <ng-container matColumnDef="tipoIntervento">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo intervento</th>
            <td mat-cell *matCellDef="let sel">{{ sel?.tipoIntervento?.descrizione }}</td>
        </ng-container>

        <ng-container matColumnDef="tipoOperatore">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo operatore</th>
            <td mat-cell *matCellDef="let sel">{{ sel?.tipoOperatore?.descrizione }}</td>
        </ng-container>

        <ng-container matColumnDef="operatore">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Operatore</th>
            <td mat-cell *matCellDef="let sel">{{ sel?.operatore?.cognome}} {{ sel?.operatore?.nome}}</td>
        </ng-container>

        <ng-container matColumnDef="strutturaRiferimento">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Struttura riferimento</th>
            <td mat-cell *matCellDef="let sel">

                <div *ngIf="sel?.strutturaRiferimento?.parentDetails">
                    <strong>Struttura padre:</strong>
                    {{sel?.strutturaRiferimento?.parentDetails.oid_2}} -
                    {{sel?.strutturaRiferimento?.parentDetails.codice}} -
                    {{sel?.strutturaRiferimento?.parentDetails.descrizione}}<br>
                </div>
                {{ sel?.strutturaRiferimento?.denominazione }}

            </td>
        </ng-container>

        <ng-container matColumnDef="frequenza">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Frequenza</th>
            <td mat-cell *matCellDef="let sel">{{sel.frequenza}}</td>
        </ng-container>

        <ng-container matColumnDef="attivita">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Attività</th>
            <td mat-cell *matCellDef="let sel">

                <div *ngFor="let attivita of  sel.attivita ">
                    - {{ attivita.descrizione }} ({{ attivita.codice }})<br>

                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsInterventoPaziente"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsInterventoPaziente;"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-results-row" [attr.colspan]="displayedColumnsInterventoPaziente.length">
                Nessun risultato.
            </td>
        </tr>
    </table>
</div>


<mat-stepper [linear]="true" #stepper>


    <mat-step [stepControl]="interventoControl" label="Interventi" [editable]="false">
        <div *ngIf="this.avanti==0">
            <div class="row mt-4 mb-4">
                <div class="col">
                    <h4>Intervento</h4>
                </div>
            </div>

            <div class="table-container">
                <table mat-table matSort [dataSource]="this.esitoUvmIniziale" multiTemplateDataRows>
                    <ng-container matColumnDef="apri">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                        <td mat-cell *matCellDef="let sel">
                            <button mat-button (click)="apriRichiesta(sel)">
                                <mat-icon>check</mat-icon> Seleziona
                            </button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="tipoIntervento">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo intervento</th>
                        <td mat-cell *matCellDef="let sel">{{ esito?.setting?.descrizione }}</td>
                    </ng-container>



                    <ng-container matColumnDef="codTipoErogatore">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo operatore</th>
                        <td mat-cell *matCellDef="let sel">{{ sel.codTipoErogatore }}</td>
                    </ng-container>

                    <ng-container matColumnDef="tipoFrequenza">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo frequenza</th>
                        <td mat-cell *matCellDef="let sel">{{ sel.tipoFrequenza }}</td>
                    </ng-container>

                    <ng-container matColumnDef="numeroAccessiPrevisti">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Numero accessi previsti</th>
                        <td mat-cell *matCellDef="let sel">{{ sel.numeroAccessiPrevisti }}</td>
                    </ng-container>





                    <ng-container matColumnDef="attivita">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Attività</th>
                        <td mat-cell *matCellDef="let sel">


                            @for (attivita of sel.attivita; track attivita) {

                            - {{attivita.descrizione}} ({{attivita.codice}})
                            <br>
                            }

                        </td>

                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell no-results-row" [attr.colspan]="displayedColumns.length">
                            Nessun risultato.
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </mat-step>


    <mat-step [stepControl]="qualificheControl" label="Qualifica" [editable]="false">
        <div class="container mb-3">
            <div class="row">
                <div class="col-md-3">
                    <h6>Intervento selezionato:</h6>
                    <br><b>Tipo intervento: </b> {{esito?.setting?.descrizione}}
                    <br><b>Tipo operatore: </b> {{interventoView?.codTipoErogatore}}
                    <br><b>Tipo frequenza: </b> {{interventoView?.tipoFrequenza}}
                    <br><b>Numero accessi previsti: </b> {{interventoView?.numeroAccessiPrevisti}}
                    <br><b>Attività: </b>
                    @for (attivita of interventoView?.attivita; track attivita) {
                    <li>
                        {{attivita.descrizione}} ({{attivita.codice}})
                    </li>
                    }
                </div>
            </div>
        </div>
        <app-qualifiche (qualificheId)="gestisciQualifiche($event)" [qualificaIntervento]="qualificaByInterventoValue"
            *ngIf="this.avanti==1"></app-qualifiche>
    </mat-step>

    <mat-step [stepControl]="operatoreControl" label="Operatore" [editable]="false">
        <div class="container mb-3">
            <div class="row">
                <div class="col-md-3">
                    <h6>Intervento selezionato:</h6>
                    <br><b>Tipo intervento: </b> {{esito?.setting?.descrizione}}
                    <br><b>Tipo operatore: </b> {{interventoView?.codTipoErogatore}}
                    <br><b>Tipo frequenza: </b> {{interventoView?.tipoFrequenza}}
                    <br><b>Numero accessi previsti: </b> {{interventoView?.numeroAccessiPrevisti}}
                    <br><b>Attività: </b>
                    @for (attivita of interventoView?.attivita; track attivita) {
                    <li>
                        {{attivita.descrizione}} ({{attivita.codice}})
                    </li>
                    }
                </div>
                <div class="col-md-2">
                    <h6>Qualifica selezionata:</h6>
                    <br>{{qualificheView}}
                </div>
            </div>
        </div>

        <app-operatori [qualificheSelezionate]="selectedQualifiche" (operatoreId)="gestisciOperatori($event)"
            *ngIf="this.avanti==2"></app-operatori>
    </mat-step>


    <mat-step [stepControl]="strutturaControl" label="Struttura" [editable]="false">
        <div class="container mb-3">
            <div class="row">
                <div class="col-md-3">
                    <h6>Intervento selezionato:</h6>
                    <br><b>Tipo intervento: </b> {{esito?.setting?.descrizione}}
                    <br><b>Tipo operatore: </b> {{interventoView?.codTipoErogatore}}
                    <br><b>Tipo frequenza: </b> {{interventoView?.tipoFrequenza}}
                    <br><b>Numero accessi previsti: </b> {{interventoView?.numeroAccessiPrevisti}}
                    <br><b>Attività: </b>
                    @for (attivita of interventoView?.attivita; track attivita) {
                    <li>
                        {{attivita.descrizione}} ({{attivita.codice}})
                    </li>
                    }
                </div>
                <div class="col-md-2">
                    <h6>Qualifica selezionata:</h6>
                    <br>{{qualificheView}}
                </div>
                <div class="col-md-2">
                    <h6>Operatore selezionato:</h6>
                    <br>{{operatoreViewNome}} {{operatoreViewCognome}}
                </div>
            </div>
        </div>

        <app-strutture [operatoriSelezionati]="selectedOperatore" (strutturaId)="gestisciStrutture($event)"
            *ngIf="this.avanti==3"> </app-strutture>
    </mat-step>

    <mat-step [stepControl]="frequenzaControl" label="Frequenza" [editable]="false">
        <div class="container mb-3">



            <div class="row">
                <div class="col-md-3">
                    <h6>Intervento selezionato:</h6>
                    <br><b>Tipo intervento: </b> {{esito?.setting?.descrizione}}
                    <br><b>Tipo operatore: </b> {{interventoView?.codTipoErogatore}}
                    <br><b>Tipo frequenza: </b> {{interventoView?.tipoFrequenza}}
                    <br><b>Numero accessi previsti: </b> {{interventoView?.numeroAccessiPrevisti}}
                    <br><b>Attività: </b>
                    @for (attivita of interventoView?.attivita; track attivita) {
                    <li>
                        {{attivita.descrizione}} ({{attivita.codice}})
                    </li>
                    }
                </div>
                <div class="col-md-2">
                    <h6>Qualifica selezionata:</h6>
                    <br>{{qualificheView}}
                </div>
                <div class="col-md-2">
                    <h6>Operatore selezionato:</h6>
                    <br>{{operatoreViewNome}} {{operatoreViewCognome}}
                </div>
                <div class="col-md-2">
                    <h6>Struttura selezionata:</h6>
                    <br>{{struttureView}}
                </div>
            </div>


        </div>

        <!--<div *ngIf="this.avanti == 4">
                <div class="row mt-4 mb-4">
                    <div class="col">
                        <h4>Frequenza</h4>
                        <div class="row d-flex">
                            <form [formGroup]="formRicerca" (ngSubmit)="gestisciFrequenza()">
                                <div class="row d-flex">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Frequenza</mat-label>
                                        <input matInput placeholder="Inserisci la frequenza" formControlName="frequenza"
                                            required />
                                        <mat-error *ngIf="formRicerca.get('frequenza')?.hasError('required')">
                                            Questo campo è obbligatorio.
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <button mat-flat-button [disabled]="formRicerca.invalid">
                                    <mat-icon>check</mat-icon>Avanti
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>-->
        <app-frequenza (valueChange)="gestisciFrequenza($event)"></app-frequenza>

    </mat-step>



    <mat-step [stepControl]="attivitaControl" label="Attività" [editable]="false">
        <div class="container mb-3">
            <div class="row">
                <div class="col-md-3">
                    <h6>Intervento selezionato:</h6>
                    <br><b>Tipo intervento: </b> {{esito?.setting?.descrizione}}
                    <br><b>Tipo operatore: </b> {{interventoView?.codTipoErogatore}}
                    <br><b>Tipo frequenza: </b> {{interventoView?.tipoFrequenza}}
                    <br><b>Numero accessi previsti: </b> {{interventoView?.numeroAccessiPrevisti}}
                    <br><b>Attività: </b>
                    @for (attivita of interventoView?.attivita; track attivita) {
                    <li>
                        {{attivita.descrizione}} {{attivita.codice}}
                    </li>
                    }
                </div>
                <div class="col-md-2">
                    <h6>Qualifica selezionata:</h6>
                    <br>{{qualificheView}}
                </div>
                <div class="col-md-2">
                    <h6>Operatore selezionato:</h6>
                    <br>{{operatoreViewNome}} {{operatoreViewCognome}}
                </div>
                <div class="col-md-2">
                    <h6>Struttura selezionata:</h6>
                    <br>{{struttureView}}
                </div>
                <div class="col-md-2">
                    <h6>Frequenza inserita:</h6>
                    <br>{{frequenzaInserita}}
                </div>
            </div>
        </div>

        <app-attivita (attivitaId)="gestisciAttvita($event)" [attivitaIntervento]="attivitaByInterventoValue"
            *ngIf="avanti==5"></app-attivita>
    </mat-step>


</mat-stepper>





<!-- 
     <app-operatori *ngIf="this.avanti==2" [qualificheSelezionate]="selectedQualifiche" (operatoreId)="gestisciOperatori($event)"></app-operatori>

    <app-strutture *ngIf="this.avanti==3" [operatoriSelezionati]="selectedOperatore" (strutturaId)="gestisciStrutture($event)"></app-strutture>   
    
    <div *ngIf="this.avanti==4" >
        <div class="row mt-4 mb-4">
            <div class="col">
                <h4>Frequenza</h4>
                <div class="row d-flex">

                    <form [formGroup]="formRicerca" (ngSubmit)="gestisciFrequenza()">
            
            
                            <div class="row d-flex">
            
                                <mat-form-field appearance="outline">
                                    <mat-label>Frequenza</mat-label>
                                    <input matInput placeholder="Inserisci la frequenza" value="" formControlName="frequenza">
                                </mat-form-field>
            
                            </div>
            
            
                            <button mat-flat-button>
                                <mat-icon>check</mat-icon>Avanti
                            </button>
            
                            <div style="margin-left: 0.2rem;"></div>
            
        
            
                    </form>

                </div>
            </div>
        </div>
    </div>
    

    <app-attivita *ngIf="this.avanti==5" (attivitaId)="gestisciAttvita($event)"></app-attivita>
ELIMINARE ID IN INTERVENTO


</div>-->



<!--<div>
        <strong>1 - Ricerca operatore</strong>
        <div>
            <mat-form-field>
                <mat-label>Cerca</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Infermiere" #input>
            </mat-form-field>

            <table mat-table [dataSource]="dataSource">

                <ng-container matColumnDef="cognome">
                    <th mat-header-cell *matHeaderCellDef> Cognome </th>
                    <td mat-cell *matCellDef="let element"> {{element.cognome}} </td>
                </ng-container>

                <ng-container matColumnDef="nome">
                    <th mat-header-cell *matHeaderCellDef> Nome </th>
                    <td mat-cell *matCellDef="let element"> {{element.nome}} </td>
                </ng-container>


                <ng-container matColumnDef="qualifica">
                    <th mat-header-cell *matHeaderCellDef> Qualifica </th>
                    <td mat-cell *matCellDef="let element"> {{element.qualifica.descrizione}} </td>
                </ng-container>


                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element"> <button mat-button><mat-icon aria-hidden="false"
                                aria-label="Aggiungi icona" fontIcon="add"></mat-icon> Aggiungi</button> </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">Nessun dato trovato per "{{input.value}}"</td>
                </tr>


            </table>

            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
                aria-label="Select page of periodic elements">
            </mat-paginator>
        </div>
    </div>-->